import { useEffect } from 'react';

import type { LeaseActionProps } from '../../../models/Types';
import { useExplainerLeaseForLeaseQuery, useExplainerLeaseFromOuidQuery } from '../../../utils/queries';
import { openStaticAsset } from '../../../utils/staticAsssets';
import { Lease, Person } from '../../../models';

export default function OpenTabExplainerLease({ lease, terminateActiveAction }: LeaseActionProps) {
  const ouid = Person.getOUIDfromSearch();
  const isOuid = !!ouid;

  const explainerLeaseQuery = useExplainerLeaseForLeaseQuery(lease.id, !isOuid);
  const explainerLeaseFromOuidQuery = useExplainerLeaseFromOuidQuery(ouid, isOuid);

  const explainerLeaseName = isOuid
    ? explainerLeaseFromOuidQuery.data?.explainerLeaseName
    : explainerLeaseQuery.data?.explainerLeaseName;

  useEffect(() => {
    if (explainerLeaseName != null) {
      openStaticAsset(Lease.getExplainerLeasePath(explainerLeaseName));
      terminateActiveAction();
    }
  }, [explainerLeaseName, terminateActiveAction]);

  return null;
}
